import { useNavigate } from 'react-router-dom';

const DocumentIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
);

export default function LoginPage() {
    const navigate = useNavigate();

    const handleLogin = () => {
        const baseUrl = "https://kediritechnopark.com/";
        const modal = "product";
        const productId = 9;

        // Ganti authorizedUri sesuai domain produksi Anda jika sudah deploy
        const authorizedUri = window.location.origin + "/select-organization?token=";
        const unauthorizedUri = `${baseUrl}?modal=${modal}&product_id=${productId}`;

        const url =
            `${baseUrl}?modal=${modal}&product_id=${productId}` +
            `&authorized_uri=${encodeURIComponent(authorizedUri)}` +
            `&unauthorized_uri=${encodeURIComponent(unauthorizedUri)}`;

        window.location.href = url;
    };

    return (
        <div className="bg-gray-100 flex items-center justify-center h-screen">
            <div className="w-full max-w-sm p-8 bg-white rounded-2xl shadow-lg text-center">
                <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center">
                        <DocumentIcon />
                    </div>
                </div>
                <h1 className="text-3xl font-bold text-gray-800">SOLID DATA</h1>
                <p className="text-gray-500 mt-2 mb-8">Kelola data dokumen Anda dengan mudah</p>
                <button
                    onClick={handleLogin}
                    className="block w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-bold py-3 px-4 rounded-lg hover:opacity-90 transition-opacity duration-300"
                >
                    Masuk
                </button>
            </div>
        </div>
    );
}